import React, { Component } from 'react';
import _, { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { Grid, Box, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import moment from 'moment';

import styles, { Status } from './styles';

class ShipmentPickupInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { pickup, shipment } = this.props;
    const pickupStatus = pickup?.status ? pickup.status : '';
    const statusColor = !!pickupStatus ? Status[pickupStatus] : Status['DEFAULT'];
    const dtFormat = moment(shipment.dropoff_latest_ts).isBefore(moment()) ? 'MM/DD hh:mm A' : 'hh:mm A';

    return (
      <Box mb={2}>
        <Accordion sx={styles.panelContainer}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={styles.panelHeader}
            classes={{ expandIconWrapper: 'panel-toggle-icon' }}
            slotProps={{ expandIconWrapper: { sx: styles.panelToggleIcon } }}
          >
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid>
                <Box sx={styles.panelHeaderTitle}>Pickup Info:</Box>
              </Grid>
              <Grid>
                <Box style={{ color: statusColor }} sx={styles.panelHeaderStatus}>
                  <span>{pickupStatus}</span>
                  {pickup?.actual_departure_ts && <span> @ {moment(pickup.actual_departure_ts).format(dtFormat)}</span>}
                </Box>
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails sx={styles.panelBody}>
            <Grid container direction="column" spacing={1}>
              <Grid>
                <Grid container justifyContent="space-between">
                  <Grid>
                    <Box sx={styles.text}>{shipment.pickup_address.street}</Box>
                    <Box sx={styles.text}>{shipment.pickup_address.street2}</Box>
                    <Box sx={styles.text}>
                      {shipment.pickup_address.city}, {shipment.pickup_address.state} {shipment.pickup_address.zipcode}
                    </Box>
                  </Grid>
                  {shipment.pickup_note && (
                    <Grid>
                      <Box sx={styles.noteLabel}>NOTES</Box>
                      <Box sx={styles.noteContent}>{shipment.pickup_note}</Box>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid>
                <Grid container justifyContent="space-between" alignItems="center" style={{ color: statusColor }} sx={styles.remarkHeader}>
                  <Grid>
                    <Box sx={styles.remarkHeaderStatus}>PICKUP REMARK</Box>
                  </Grid>
                  {pickupStatus && (
                    <Grid>
                      <Box sx={styles.remarkHeaderTime}>
                        {_.capitalize(pickupStatus)}
                        {pickup?.actual_departure_ts && <span> @ {moment(pickup.actual_departure_ts).format(dtFormat)}</span>}
                      </Box>
                    </Grid>
                  )}
                </Grid>
                <Box sx={{ ...styles.remarkContent, borderColor: statusColor }}>
                  {pickup?.remark ? pickup.remark : '-'}
                </Box>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    );
  }
}

export default compose(inject('store'), observer)(ShipmentPickupInfo);
